export const GET_GAS_PRICE = 'parcel/gas/GET_GAS_PRICE';
export const GET_GAS_PRICE_SUCCESS = 'parcel/gas/GET_GAS_PRICE_SUCCESS';
export const GET_GAS_PRICE_ERROR = 'parcel/gas/GET_GAS_PRICE_ERROR';
